import { render, staticRenderFns } from "./SymposiaDetail.view.vue?vue&type=template&id=22d564ae&scoped=true"
import script from "./SymposiaDetail.view.vue?vue&type=script&lang=js"
export * from "./SymposiaDetail.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d564ae",
  null
  
)

export default component.exports